<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>CAMPUS LIFE</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Bus Facility</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>


<section>
    <div class="container">
        <div class="section-heading text-start mb-0 text-center">
            <span class=" sub-title">All are Fuly Wi-Fi Blocks</span>
        </div>
        <h2 class="text-center">Our Transport</h2>
        <p>The University caters for a “Pick up from Home” facility for our students from all the surrounding areas of
            Himachal Pradesh, Punjab and J&K. Transport charges are required to be paid in full, in advance, in the
            beginning for the whole Semester Charges once paid, cannot be withdrawn. The areas connected are.</p>
        <ul>
            <li>Talwara – Mukerian – Arni</li>
            <li>Kathua – Pathankot- Arni</li>
            <li>Bhadwar – Nurpur- Arni</li>
            <li>Mehra Phatak-Gangath-Arni</li>
            <li>Jawali- Indora- Arni</li>
            <li>Dhameta-Rahan- Arni</li>
            <li>Badukhar-Indora-Arni</li>
        </ul>
        <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-12 mt-5">
                <img src="assets/img/hostel/TPT1.jpg" class="cover-background w-100 h-100"/>
            </div>

            <div class="col-lg-3 col-md-3 col-sm-12 mt-5">
                <img src="assets/img/hostel/TPT2.jpg" class="cover-background w-100 h-100"/>
            </div>

            <div class="col-lg-3 col-md-3 col-sm-12 mt-5">
                <img src="assets/img/hostel/TPT3.jpg" class="cover-background w-100 h-100"/>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-12 mt-5">
                <img src="assets/img/hostel/TPT4.jpg" class="cover-background w-100 h-100"/>
            </div>
        </div>
    </div>
</section>
